<template>
  <!-- 跳转大转盘（原有） 线上type =2  -->
  <div class="luckdraw">
    <div class="luckdraw_bg">
      <img src="../../assets/img/luckbg.png" alt class="luckbg" />
      <div class="luckydraw_log" @click="go_list">
        <p class="text_ch">抽奖记录</p>
        <p class="text_en">Lucky draw</p>
        <img class="po_cpo_casas" src="../../assets/img/lw.png" />
      </div>
      <div class="my_jf">
        <img src="../../assets/img/jifen.png" alt />
        <p v-if="userinfo">我的积分：{{ userinfo.amount  }}</p>
      </div>
      <div class="luckdraw_box">
        <div class="animation_box turntable" ref="turntable">
          <img src="../../assets/img/pan.png?timestamp='+new Date().getTime()+'" alt class="luckdraw_pan" />
          <!-- <div
            v-for="(item,index) in prizelist"
            :key="index"
            :class="'luckdraw_item luckdraw_item'+index"> 
            <div class="luckdraw_item_img">
              <img :src="item.img_url" alt />
            </div>
            <p class="prize_name">{{item.prize_name | filter_length(item.prize_name)}}</p>
          </div> -->
        </div>
        <img src="../../assets/img/button.png" alt class="luckdraw_btn" @click="show = true" />
      </div>
      <div class="rule" v-html="rule"></div>
    </div>
    <div class="show_popup" v-if="show_popup"></div>

    <!-- <div class="popup_wintheprize" v-if="show1">
      <div class="popup_w_box" style="padding-top:12px">
        <img src="../assets/img/lw.png" />
        <h5 class="wintheprize_tit">恭喜！您已抽中<span class="wintheprize_name">{{ wintheprize_name }}</span></h5>
        <p class="wintheprize_text_ch">立即领取吧！</p>
        <p class="wintheprize_text_en">Congrats! Click to claim</p>
        <div class="btn_confirm godetails" @click="show1= false">
          <span class="btn_one_ch">好的</span>
          <span class="btn_one_en">Claim</span>
        </div>
      </div>
    </div> -->
    <!-- <div class="popup_wintheprize" v-if="success">
      <div class="popup_w_box" style="padding-top:46px">
        <h5 class="wintheprize_tit">领取成功！</h5>
        <p class="wintheprize_text_ch">订单编号：</p>
        <p class="wintheprize_text_en">Order NO</p>
        <button class="godetails" @click="godetails()">领取</button>
        <div class="popup_btns" style="margin-top:20px">
          <div class="btn_cancel" @click="success = false; show = true;">
            <span class="btn_one_ch">再次抽奖</span>
            <span class="btn_one_en">Try Again</span>
          </div>
          <div class="btn_confirm" @click="look">
            <span class="btn_one_ch">查看抽奖记录</span>
            <span class="btn_one_en">Check Record</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="popup_wintheprize" v-if="show3">
      <div class="popup_w_box show3_box" style="padding-top:12px">
        <img src="../../assets/img/lw.png" />
        <h5 class="wintheprize_tit">恭喜！您已抽中<span class="wintheprize_name">{{ wintheprize_name }}</span></h5>
        <!-- <p class="wintheprize_text_ch" v-if="actives.is_coupon != 1">将于3个工作日内发放到您的账户，请注意查收</p>
        <p class="wintheprize_text_en" v-if="actives.is_coupon != 1">Congrats! Prize will be sent in 3 working days</p> -->
        <!-- <button class="godetails" @click="godetails()">领取</button> -->
        <!-- localStorage.setItem("prize", JSON.stringify(item)); -->
        <div class="btn_confirm godetails" @click="show3= false">
          <span class="btn_one_ch">好的</span>
        </div>
      </div>
    </div>
    <!-- <div :class="show_page_add ? 'input_adddress inputOpen' : 'input_adddress'">
      <div class="popup_box popup_box2">
        <div class="form">
          <div class="i_a_tit">填写收货地址</div>
          <div class="formItem">
            <div class="label">
              <div class="zh">姓名</div>
              <div class="en">Name</div>
            </div>
            <input type="text" class="value" placeholder="请输入收件人姓名" v-model="params.send_username" />
          </div>
          <div class="formItem">
            <div class="label">
              <div class="zh">手机</div>
              <div class="en">Tel</div>
            </div>
            <input type="tel" class="value" placeholder="请输入收件人手机号码" maxlength="11" v-model="params.send_phone" />
          </div>
          <div class="formItem">
            <div class="label">
              <div class="zh">城市</div>
              <div class="en">City</div>
            </div>
            <van-cell class="value" is-link @click="show_address = true">
              <span v-if="!params.send_province">所在省市区</span>
              <span style="line-height:20px"
                v-else>{{ params.send_province }}{{ params.send_city }}{{ params.send_area }}</span>

            </van-cell>
          </div>
          <div class="formItem areatext">
            <div class="label">
              <div class="zh">详细地址</div>
              <div class="en">Address</div>
            </div>
            <textarea class="value" cols="30" rows="10" placeholder="请填写详细地址" v-model="params.send_addr"></textarea>
          </div>
          <div class="i_a_btn" @click="submit">
            <span class="btn_one_ch">领取</span>
            <span class="btn_one_en">Claim</span>
          </div>
        </div>
      </div>
      <img class="close_popup" @click="show_page_add = false" src="./../assets/img/close_img.png" alt="">
    </div> -->
    <!-- <van-popup v-model="show_address" position="bottom">
      <van-area :area-list="areaList" :value="value" @cancel="show_address = false" @confirm="click_address" />
    </van-popup> -->
    <!-- <div class="popup_wintheprize" v-if="show2">
      <div class="popup_w_box">
        <h5 class="wintheprize_tit">很遗憾，未中奖！</h5>
        <p class="wintheprize_text_en">What a pity!</p>
        <img src="./../assets/img/daidai3.png" />
        <p class="wintheprize_tit">{{wintheprize_name}}</p>
        <p class="wintheprize_tit_en">What a pity! Better luck next time.</p>
        <p class="wintheprize_text_ch">一直抽不到？试试积分兑礼吧</p>
        <p class="wintheprize_text_en"> Try other redemption </p>
        <button class="goback" @click="goback()">返回</button>

        <div class="popup_btns" style="margin-top:20px">
          <div class="btn_cancel" @click="goback()">
            <span class="btn_one_ch">返回抽奖</span>
            <span class="btn_one_en">Back</span>
          </div>
          <div class="btn_confirm" @click="go_redemption()">
            <span class="btn_one_ch">积分兑换</span>
            <span class="btn_one_en">Redemption</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="popup_wintheprize" v-if="show">
      <div class="popup_w_box">
        <p class="wintheprize_tit">您是否确认花费{{ score }}积分抽奖一次</p>
        <p class="wintheprize_tit_en">Use {{ score }} points to redeem a chance for lucky draw</p>
        <div class="popup_btns">
          <div class="btn_cancel" @click="show = false">
            <span class="btn_one_ch">取消</span>
            <span class="btn_one_en">Cancel</span>
          </div>
          <div class="btn_confirm" @click="click_start()">
            <span class="btn_one_ch">确认</span>
            <span class="btn_one_en">Confirm</span>
          </div>
        </div>
      </div>
    </div>

    <!-- </van-dialog> -->
    <!-- <div class="add_wintheprize">
      <img class="logo" src alt />
      <div class="wintheprize_box">
        <div>{{}}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
var qs = require("qs");
import AreaList from "../../assets/area.js";
import wx from 'weixin-js-sdk';
export default {
  name: "index",
  props: {
    msg: String
  },
  data() {
    return {
      areaList: AreaList,
      params: {
        ut: "",
        id: "",
        send_username: "",
        send_phone: "",
        send_province: "",
        send_city: "",
        send_area: "",
        send_addr: ""
      },
      value: "",
      show_address: false,
      show_page_add: false,
      success: false,
      show: false,
      show1: false,
      show2: false,
      show3: false,
      prizelist: "",
      rule: "<p style=\"text-align:center;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">幸运大转盘活动规则（仅作演示，请勿当真）</span> \r\n</p>\r\n<p style=\"text-align:center;\">\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\"></span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;<span style=\"font-family:微软雅黑;\">Rules</span></span></strong> \r\n</p>\r\n<p style=\"text-align:center;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">活动时间：</span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">2023</span><span style=\"font-family:微软雅黑;font-size:12px;\">年</span><span style=\"font-family:微软雅黑;font-size:12px;\">7</span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">月</span><span style=\"font-family:微软雅黑;\">12</span></span><span style=\"font-family:微软雅黑;font-size:12px;\">日</span><span style=\"font-family:微软雅黑;font-size:12px;\">00:00:00-2023</span><span style=\"font-family:微软雅黑;font-size:12px;\">年</span><span style=\"font-family:微软雅黑;font-size:12px;\">8</span><span style=\"font-family:微软雅黑;font-size:12px;\">月</span><span style=\"font-family:微软雅黑;font-size:12px;\">1</span><span style=\"font-family:微软雅黑;font-size:12px;\">日</span><span style=\"font-family:微软雅黑;font-size:12px;\">23:59:59</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">Event time: </span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">00:00:00 on July </span><span style=\"font-family:微软雅黑;font-size:12px;\">11</span><span style=\"font-family:微软雅黑;font-size:12px;\">, 2023 - 23:59:59 on </span><span style=\"font-family:微软雅黑;font-size:12px;\">August</span><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">1</span><span style=\"font-family:微软雅黑;font-size:12px;\">, 2023</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">活动参与对象：</span></strong><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">本活动所有会员（以下简称</span><span style=\"font-family:微软雅黑;\">“用户”）均可参与，但不包括第三方平台的会员，如京东到家、美团、饿了么等第三方平台的会员。您可通过</span></span><span style=\"font-family:微软雅黑;font-size:12px;\"></span><span style=\"font-family:微软雅黑;font-size:12px;\">商城微信小程序和线下门店注册成为会员</span><span style=\"font-family:微软雅黑;font-size:12px;\">参与本活动</span><span style=\"font-family:微软雅黑;font-size:12px;\">。</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">Eligibility: </span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">All  members (hereinafter referred to as \"users\") are eligible to participate in this activity, </span><strong><span style=\"font-family:微软雅黑;font-size:12px;\">excluding  members via third-party platforms, such as JD Daojia, Meituan, Ele.me, etc.</span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;You can register as an  member through the  WeChat Mini program and  physical stores to participate in this event.</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">活动参与渠道：</span></strong><span style=\"font-family:微软雅黑;font-size:12px;\"></span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">商城微信小程序（下称</span><span style=\"font-family:微软雅黑;\">“小程序“）</span></span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:Calibri;font-size:14px;\">Entry to the event: </span></strong><span style=\"font-family:Calibri;font-size:14px;\"> Mall WeChat Mini program (hereinafter referred to as \"Mini program\")</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">活动规则：</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">Rules：</span></strong> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:' SUED Office';font-weight:bold;font-size:12px;\">1.&nbsp;</span><strong><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">用户登录小程序首页点击【奥家扭蛋机】活动页面（下称</span><span style=\"font-family:微软雅黑;\">“活动页面”）。进入活动页面后，用户可通过点击“扭一扭”按钮参与</span></span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">抽奖</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">活动。</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">The user logs in to the homepage of </span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">W</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">e</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">C</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">hat </span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">M</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">ini </span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">P</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">rogram and clicks on the activity page of [ Lucky Draw] (hereinafter referred to as the \"activity page\"). After entering the activity page, the user can participate in the lucky draw by clicking the \"Twist\" button.</span></strong> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:' SUED Office';font-weight:bold;font-size:12px;\">2.&nbsp;</span><strong><span style=\"font-family:微软雅黑;font-size:12px;\">每参加一次抽奖，需消耗</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">100</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">会员积分</span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">。在会员积分充足的前提下，用户可多次参加抽奖。</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">Each entry to the draw will cost 100 </span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;<span style=\"font-family:微软雅黑;\">m</span></span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">ember points. </span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">Under the premise of sufficient member points, users can participate in the lucky draw multiple times.</span> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:' SUED Office';font-size:12px;\">3.&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">抽奖结果详情</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">Details of Lucky draw results</span> \r\n</p>\r\n<p>\r\n\t \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">*</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">备注：</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">*Remark:</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">1) </span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">橘子脱口秀门票为</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">2023</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">年</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">05</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">月</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">20</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">日</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">在</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">对应官方渠道查询到的售价，仅供参考</span></strong><span style=\"font-family:宋体;font-size:14px;\">。</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">2) </span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">奖品数量有限，先到先得。</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">1) Soda stand-up comedy tickets for May 20, 2023 corresponding to the official channel inquiries of the price, for reference only.</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">2) The number of prizes is limited, first come, first served. </span></strong> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:' SUED Office';font-size:12px;\">4.&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">奖品领取方式</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">How to claim the </span><span style=\"font-family:微软雅黑;font-size:12px;\">rewards</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">若用户获得的是会员</span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">积分，小程序将在用户中奖后的</span><span style=\"font-family:微软雅黑;\">1个工作日内将相应会员积分发放至用户的账户</span></span><span style=\"font-family:微软雅黑;font-size:12px;\">，</span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">用户可以在【小程序</span><span style=\"font-family:微软雅黑;\">-我</span></span><span style=\"font-family:微软雅黑;font-size:12px;\">-</span><span style=\"font-family:微软雅黑;font-size:12px;\">积分】进行查询。会员积分的有效期及使用规则请</span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">参照【小程序</span><span style=\"font-family:微软雅黑;\">-我-帮助中心-积分规则】</span></span><span style=\"font-family:微软雅黑;font-size:12px;\">。</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">If a user gets points, the Mini Program will release the corresponding  member points to the user's account within 1 working day after the user wins the prize, and the user can inquire in the \"Mini Program - ME- Points\". The validity period and use rules of the  member points can be seen in the \"Mini Program - Me - Help Center - Points Rules\".</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">2</span><span style=\"font-family:微软雅黑;font-size:12px;\">）若用户获得的是实体礼品卡、橘子脱口秀门票、</span><span style=\"font-family:微软雅黑;font-size:12px;\"></span><span style=\"font-family:微软雅黑;font-size:12px;\">飞盘或者</span><span style=\"font-family:微软雅黑;font-size:12px;\"> </span><span style=\"font-family:微软雅黑;font-size:12px;\">拉杆车，用户需在中奖后</span><span style=\"font-family:微软雅黑;font-size:12px;\">3</span><span style=\"font-family:微软雅黑;font-size:12px;\">个自然日内填写配送信息，配送信息可以在获奖后的弹窗内填写或通过小程序进入活动页面点击【我的奖品】填写。奖品会在用户提交配送信息后</span><span style=\"font-family:微软雅黑;font-size:12px;\">8</span><span style=\"font-family:微软雅黑;font-size:12px;\">个工作日内发货，用户可在活动主页点击【我的奖品】查看快递信息（寄送状态和快递单号）。</span><strong><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">如用户未在前述时间内填写配送信息，则视作用户放弃奖品，该奖品将显示为</span><span style=\"font-family:微软雅黑;\">“已失效”。</span></span></strong> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">If the prize is </span><span style=\"font-family:微软雅黑;font-size:12px;\"></span><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">physical gift card</span><span style=\"font-family:微软雅黑;font-size:12px;\">s</span><span style=\"font-family:微软雅黑;font-size:12px;\">、</span><span style=\"font-family:微软雅黑;font-size:12px;\">a ticket to Soda stand-up comedy、 frisbee or  rod car</span><span style=\"font-family:微软雅黑;font-size:12px;\">, </span><strong><span style=\"font-family:微软雅黑;font-size:12px;\">the user must fill in the delivery information within 3 natural days after winning the prize.</span></strong><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;The prize will be shipped within 8 working days after the user submits the delivery information, and the user can check the courier information (delivery status and reference number) by taping [My Prizes] on the activity homepage. </span><strong><span style=\"font-family:微软雅黑;font-size:12px;\">Should the user fail to fill in the delivery information within the aforementioned time frame, the prize will be regarded as relinquished by the user and the physical prize will be registered as \"expired\".</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;</span></strong> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">3)</span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">橘子脱口秀门票的具体服务由橘子脱口秀提供，建议中奖用户仔细阅读门票所载的相关规则说明。以下预约使用方式供用户参考：用户可扫描门票上的二维码添加橘子脱口秀官方公众号并关注，关注成功后，点击下方菜单栏</span><span style=\"font-family:微软雅黑;\">“购票排期-预约演出”，添加官方客服人员并将蓝色门票拍照发给客服工作人员，与客服工作人员预约需要观看演出的时间和观演人数。预约完成后按照预约时间入场观演。</span></span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">橘子脱口秀客服电话：</span><span style=\"font-family:微软雅黑;\">13524898373</span></span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">门票使用期限：</span><strong><span style=\"font-family:微软雅黑;font-size:12px;\">2023年7</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">月</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">12</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">日</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">-2024年6月30日</span></strong> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">The specific services of</span><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">Soda stand-up comedy</span><span style=\"font-family:微软雅黑;font-size:12px;\">,are provided by Orange Talk Show, and it is recommended that the winning users carefully read the relevant rules and regulations contained in the tickets.</span><span style=\"font-family:微软雅黑;font-size:12px;\">The following booking methods are for users' reference:Scan the QR code on the ticket to add the official public account of the Soda Comedy Club and follow it. Click on the menu bar “购票排期-预约演出”, add the official customer service staff and send the &nbsp;stand-up comedy ticket photo to the customer service staff to explain the purpose of coming, and make an appointment with the customer service staff for the time and number of people who want to watch the performance. After the reservation is completed, show the ticket to the ticket checking staff to recover.</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">Customer Service Phone：13524898373</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">Duration of the tickets: </span><span style=\"font-family:微软雅黑;font-size:12px;\">July</span><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;<span style=\"font-family:微软雅黑;\">1</span></span><span style=\"font-family:微软雅黑;font-size:12px;\">2</span><span style=\"font-family:微软雅黑;font-size:12px;\">, 2023 - June 30, 2024</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;</span> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">其他说明</span></strong> \r\n</p>\r\n<p>\r\n\t<strong><span style=\"font-family:微软雅黑;font-size:12px;\">A</span></strong><strong><span style=\"font-family:微软雅黑;font-size:12px;\">dditional</span></strong> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">1.&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\"><span style=\"font-family:微软雅黑;\">如用户存在违规行为（包括但不限于虛假交易、通过技术手段或其他作弊行为获取相应权益进行盈利、不当使用、违背诚实信用等行为），有权取消用户参与本次活动的资格，并收回奖品和</span>/或优惠权益（包括已使用和未使用的）或冻结违规账号，同时将依照相关规则或法律法规进行处理。</span> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">Should</span><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;the user violate the rules (including but not limited to, fraudulent transactions, obtaining the benefits for profit through technical means or other acts of cheating, improper usage, dishonesty, etc.),  has the right to disqualify the user from participating in this activity and revoke the prizes and/or benefits (including used and unused ones) or freeze the infringing account, and may take further actions in accordance with relevant laws and regulations.</span> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">2.&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">为了给用户更好的活动体验，活动内容如果有补充，会在活动开始前在小程序上与用户沟通。</span> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">In order to optimize the experience of users, if there are any additions to the event, the sponsor will communicate with users via the  mini program before the event starts.</span> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">3.&nbsp;</span><span style=\"font-family:微软雅黑;font-size:12px;\">涉及到使用快递配送奖品的情形下，用户同意提供姓名、通信地址、联系方式。这些信息可能包括个人敏感信息（如个人电话号码、姓名、地址信息），需使用这些信息向您发送奖品。也需要将您的个人信息与授权合作伙伴包括技术服务商、物流公司等共享。</span> \r\n</p>\r\n<p style=\"margin-left:24px;\">\r\n\t<span style=\"font-family:微软雅黑;font-size:12px;\">The user</span><span style=\"font-family:微软雅黑;font-size:12px;\">&nbsp;will be required to agree to provide name, postal address and contact details for courier delivery. This may include sensitive personal information (e.g., personal phone number, name, address information) which we need to deliver gifts to you. We may need to share your personal information with authorized partners including technical service providers, logistics companies, etc.</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;line-height:114%;font-size:12px;\">4.活动所涉及的所有时间节点以小程序系统判定为准。</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;line-height:114%;font-size:12px;\">All time points involved in the event are subject to the determination of the  mini program.</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:微软雅黑;line-height:114%;font-size:12px;\">5.本活动的主办方为（中国）投资有限公司。如果您有任何疑问或需要帮助，您可以在小程序内直接联系在线客服。</span> \r\n</p>\r\n<p>\r\n\t<span style=\"font-family:Calibri;line-height:114%;font-size:13px;\">The sponsor of this event is  (China) Investment Co., Ltd. If you have any questions or need help, please contact the online Customer Services directly within the  mini program.</span> \r\n</p>\r\n<p>\r\n\t<br />\r\n</p>",
      userinfo: {
        amount : 0
      },
      text: "",
      rotate: "",
      show_popup: false,
      score: "",
      wintheprize_name: "",
      wintheprize_img: "",
      widthaa: '',
      prize_info: '',
      actives: {},
      prize_list:[]
    };
  },
  created() {

    // console.log(document.body.clientWidth)
    // this.widthaa = document.body.clientWidth
    // this.heightaa = document.body.clientHeight
    // localStorage.setItem("ut", decodeURIComponent('%40%25%5E%2A8jAyQRSST6g2r72BPUBCSUGjbtUe6NSQL9wrIXl3S6k%3D'));
    // localStorage.setItem("userid", decodeURIComponent('%40%25%5E%2A8jAyQRSST6g2r72BPUBCSUGjbtUe6NSQL9wrIXl3S6k%3D'));
    // if (location.href.indexOf("?") != -1) {
    //   // if(location.href.indexOf("#") != -1){
    //   //   var arr2 = location.href.split("#")[0]
    //   //   var arr = arr2.split("?")[1];
    //   // }else{
    //   var arr = location.href.split("?")[1];
    //   console.log(arr)
    //   // }
    //   var arr1 = arr.split("&");
    //   for (var i = 0; i < arr1.length; i++) {
    //     if (arr1[i].split("=")[0] == "ut") {
    //       localStorage.setItem("ut", arr1[i].split("=")[1]);
    //     }
    //     if (arr1[i].split("=")[0] == "userid") {
    //       console.log(arr1[i].split("=")[1].split('#'))
    //       if (arr1[i].split("=")[1].split('#')) {
    //         localStorage.setItem("userid", arr1[i].split("=")[1].split('#')[0]);
    //       } else {
    //         localStorage.setItem("userid", arr1[i].split("=")[1]);
    //       }
    //     }
    //   }
    // }
    this.getprize();
    this.getUser();
    // if (localStorage.getItem("addres")) {
    //   this.getUserAddress();
    // }
  },
  methods: {
    // 默认地址
    // getUserAddress() {
    //   // 请求用户地址
    //   this.$axios({
    //     method: "post",
    //     url: this.$url + "/Api/User/getUserAddress",
    //     data: qs.stringify({
    //       ut: localStorage.getItem("ut"),
    //     }),
    //   }).then((res) => {
    //     if (res.data.code == 1) {
    //       var getUserAddress = res.data.data
    //       localStorage.setItem("getUserAddress_diamond", JSON.stringify(getUserAddress.diamond));
    //       localStorage.setItem("getUserAddress_normal", JSON.stringify(res.data.data.normal));
    //       var getUserAddress = JSON.parse(localStorage.getItem("getUserAddress_normal"))
    //       console.log('getUserAddress=', getUserAddress)
    //       this.params.send_username = getUserAddress.send_username || ''
    //       this.params.send_phone = getUserAddress.send_phone || ''
    //       this.params.send_province = getUserAddress.send_province || ''
    //       this.params.send_city = getUserAddress.send_city || ''
    //       this.params.send_area = getUserAddress.send_area || ''
    //       this.params.send_addr = getUserAddress.send_addr || ''
    //     }
    //   });
    // },
    // go_redemption() {
    //   wx.miniProgram.navigateTo({ url: "/packAgeA/pages/cms-pages/cms-pages?pageId=2106010001478253" });
    // },
    // confirmShow() {
    //   this.show3 = false;
    //   if (this.actives.is_coupon != 3) {
    //     localStorage.setItem("prize", JSON.stringify(this.actives));
    //     this.$router.push({ path: "/luckdrawdetails" });
    //   }
    // },
    // click_address(e) {
    //   console.log(e);
    //   this.params.send_province = e[0].name;
    //   this.params.send_city = e[1].name;
    //   this.params.send_area = e[2].name;
    //   //this.params.code = e[2].code;
    //   //this.params.value = e[2].code;
    //   this.show_address = false;
    // },
    //领取实物
    // submit() {
    //   if (!this.params.send_username) {
    //     this.$toast({
    //       mask: true,
    //       message: "请输入姓名",
    //       zIndex: 999999
    //     });
    //     return;
    //   }
    //   if (!/^1[3456789]\d{9}$/.test(this.params.send_phone)) {
    //     this.$toast({
    //       mask: true,
    //       message: "请输入正确的手机号",
    //       zIndex: 999999
    //     });
    //     return;
    //   }
    //   if (!this.params.send_province) {
    //     this.$toast({
    //       mask: true,
    //       message: "请选择省市区",
    //       zIndex: 999999
    //     });
    //     return;
    //   }
    //   if (!this.params.send_addr) {
    //     this.$toast({
    //       mask: true,
    //       message: "请输入详细地址",
    //       zIndex: 999999
    //     });
    //     return;
    //   }
    //   console.log(JSON.stringify({
    //     ...this.params,
    //     ut: localStorage.getItem("ut")
    //   }));
    //   this.$axios({
    //     method: "post",
    //     url: this.$url + "/Api/Score/add_address",
    //     data: qs.stringify({
    //       ...this.params,
    //       ut: localStorage.getItem("ut")
    //     })
    //   }).then(res => {
    //     this.$toast({
    //       message: res.data.msg,
    //       zIndex: 999999
    //     });
    //     if (res.data.code == 1) {
    //       this.show_page_add = false;
    //       this.$router.push({
    //         path: "/luckdrawEntity",
    //         query: {
    //           ...this.params,
    //           ...this.actives
    //         }
    //       })
    //     }

    //     // this.userinfo = res.data.data;
    //   });
    // },
    // goback() {
    //   this.show2 = false;
    // },
    // godetails() {
    //   // 1.卡卷  2.优惠卷  3.积分 4.实物
    //   if (this.actives.is_coupon == 4) {
    //     this.show_page_add = true;
    //   } else {
    //     this.golist();
    //   }
    //   this.show1 = false;
    // },
    go_list() {
      this.$router.push({ path: "/H5_luckdrawlist" });
    },
    getprize() {
      // var data = qs.stringify({
      //   ut: localStorage.getItem("ut"),
      //   userid: localStorage.getItem("userid"),

      // });
      // this.$axios({
      //   method: "post",
      //   url: this.$url + "/Api/Score/prize",
      //   data: data
      // }).then(res => {
        // this.prizelist = res.data.data.prize;
        // this.rule = res.data.data.rule;
        this.score = "5";
      // });
    },
    getUser() {
      // var data = qs.stringify({
      //   ut: localStorage.getItem("ut"),
      //   userid: localStorage.getItem("userid"),
      // });
      // this.$axios({
      //   method: "post",
      //   url: this.$url + "/Api/Score/getUser",
      //   data: data
      // }).then(res => {
      //   console.log(res);
        // this.userinfo = {
        //   amount:100,
      // };
      if (!localStorage.getItem('amount')) { 
        localStorage.setItem('amount', 60)
        this.userinfo.amount = localStorage.getItem('amount')
      } else {
        this.userinfo.amount = localStorage.getItem('amount')
      }
      // });
    },
    // look() {
    //   this.$router.push({ path: "/luckdrawlist" });
    // },
    // golist() {
    //   var that = this
    //   var data = qs.stringify({
    //     ut: localStorage.getItem("ut"),
    //     userid: localStorage.getItem("userid"),
    //     prize_id: JSON.parse(localStorage.getItem("prize")).prize_id,
    //     id: JSON.parse(localStorage.getItem("prize")).id,
    //   });
    //   //虚拟
    //   this.$axios({
    //     method: "post",
    //     url: this.$url + "/Api/Score/save_info",
    //     data: data
    //   }).then(res => {
    //     console.log(res);
    //     this.success = true;
    //     // this.userinfo = res.data.data;
    //   });
    // },
    // start_game() {
    //   this.show = true;
    // },
    // closr_popup() {
    //   console.log("取消");
    //   this.show = false;
    // },
    // 确定抽奖
    click_start() {
      var that = this;
      that.show_popup = true;
      that.show = false;
      var arr = [];
      let amount = localStorage.getItem('amount')
      if (amount <= 0) { 
        
        this.$toast({
          // mask: true,
          duration: 1000,
          message: "积分不足",
          zIndex: 999999,
        });
        that.show_popup = false;
        return false
      }
      amount = amount - 5
      localStorage.setItem('amount', amount)
      this.userinfo.amount = localStorage.getItem('amount')
      // that.prizelist.forEach((e) => {
      //   arr.push({ "id": e.id, "level": e.level })
      // })
      // var data = qs.stringify({
      //   ut: localStorage.getItem("ut"),
      //   userid: localStorage.getItem("userid"),
      //   // jsonstr:JSON.stringify(arr)
      //   jsonstr: arr
      // });
      // this.$toast({
      //   mask: true,
      //   duration: 0,
      //   message: "加载中...",
      //   zIndex: 999999,
      // });
      // that.$axios({
      //   method: "post",
      //   url: this.$url + "/Api/Score/getPrize",
      //   data: data
      // })
      //   .then(res => {
      //     that.getUser()
      //     // 获取数据 36

      //     //   res.data ={
      //     //       data:{level:2}
      //     //   }
      //     //   res.data.code = 1;
      //     this.$toast.clear()
      //     console.log(res.data.data);
      //     if (res.data.code == 1) {
            // localStorage.setItem("prize", JSON.stringify(res.data.data));
            that.wintheprize_name = '优酷月卡';
            // that.wintheprize_img = 'img/lw.b3dcac71.png';
            that.rotate = 3600 + parseInt(Math.random() * 25 + 5) + 36 * (5 - 1);
            // this.params.id = res.data.data.id;
            // this.actives = res.data.data;
          // } else {
          //   that.$toast({
          //     mask: true,
          //     message: res.data.msg,
          //     zIndex: 999999
          //   });
          //   that.show_popup = false;
          // }
          console.log(this.rotate);
          that.$refs.turntable.style.transform =
            "rotate(" + this.rotate + "deg)";
          that.$refs.turntable.style.transition = "all 5s";

          setTimeout(() => {
            that.show_popup = true;
            if (!localStorage.getItem('picInfo')) {
              const picInfo = [
                {
                  prize_name: '优酷月卡',
                  add_time: new Date().getTime()
                }
              ]
              localStorage.setItem('picInfo', JSON.stringify(picInfo))
            } else { 
              const picInfo = JSON.parse(localStorage.getItem('picInfo'))
              picInfo.push({
                prize_name: '优酷月卡',
                add_time: new Date().getTime()
              })
              localStorage.setItem('picInfo',JSON.stringify(picInfo))
            }
            

            this.actives.is_coupon = 1
            //1.卡卷  2.优惠卷  3.积分 4.实物
            if (this.actives.is_coupon == 1) {
              that.show3 = true;
            } else if (this.actives.is_coupon == 2) {
              that.show3 = true;
            } else if (this.actives.is_coupon == 3) {
              that.show3 = true;
            } else if (this.actives.is_coupon == 4) {
              that.show1 = true;
            }

            setTimeout(() => {
              //     this.get_address();
              that.show_popup = false;
              //     this.show_popup_one = false;
              that.$refs.turntable.style.transition = "all 0s";
              that.$refs.turntable.style.transform = "rotate(0deg)";
            }, 3000);
          }, 5500);
        // });

    },
    start_game() {
      var that = this;
      // this.$dialog
      //   .confirm({
      //     title: "您是否确认花费" + that.score + "积分抽奖一次",
      //     message: "Use " + that.score + " points to redeem a chance for lucky draw",
      //     showConfirmButton: true,
      //     confirmButtonText:'确认\n\nConfirm'
      //   })
      //   .then(() => {
      // on confirm
      that.show = true;
    }
  },
  filters: {
    filter_length(e) {
      // console.log(this.show123)
      return e.substring(0, 6);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.po_cpo_casas{
  position: absolute;
  top: 0;
  left: -99999999999px;
}
.luckdraw {
  width: 100%;
  height: 100%;
  background: #f2f5f8;
}

.popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1500;
}

.popup_box {
  width: 612px;
  /* height: 367px; */
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  box-sizing: border-box;
  padding: 31px 41px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.popup_box2 {
  background: #fff;
}

.popup_content {
  text-align: center;
}

.popup_name {
  width: 100%;
  font-size: 30px;

  font-weight: bold;
  color: rgba(23, 26, 29, 1);
  box-sizing: border-box;
  padding: 0 20px;
}

.popup_tip {
  font-size: 24px;

  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 16px;
}

.btns {
  width: 100%;
  box-sizing: border-box;
  padding: 0 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 100px;
}

.btns button {
  width: 236px;
  height: 78px;
  background: rgba(240, 241, 247, 1);
  opacity: 1;
  border-radius: 8px;
  border: none;
  font-size: 30px;

  color: #171a1d;
}

.btns .btn_ok {
  background: #06c0f6;
  color: rgba(255, 255, 255, 1);
}

.van-popup {
  background: none;
}

.loading_box {
  /* width: 50%; */
  /* height: 50%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup_loading_box {
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
}

.popup_loading {
  width: 200px;
}

.popup_tit {
  font-size: 30px;

  font-weight: bold;
  color: #fff;
  margin: 10px 0 5px;
}

.popup_content {
  font-size: 24px;

  font-weight: 400;
  color: #fff;
}

.i_a_tit {
  font-size: 36px;

  font-weight: normal;
  color: #171A1D;
  line-height: 50px;
  font-weight: 900;
  margin-bottom: 26px;
  text-align: center;
}

.van-cell__value {
  overflow: initial;
  text-align: right;
}

.input_adddress {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all 0.2s;
  transform: scale(0);
}

.input_adddress.inputOpen {
  transform: scale(1);
}

.close_popup {
  width: 74px;
  height: 74px;
  margin-top: 20px;
}

.i_a_btn {
  width: 100%;
  height: 78px;
  background: #06c0f6;
  opacity: 1;
  border-radius: 0.13333rem;
  border: none;
  font-size: 30px;

  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-top: 31px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  
}
.zh {
    font-size: 28px;
  }

.en {
    font-size: 18px;
  }

.click_area {
  width: 100%;
  border-radius: 10px;
  font-size: 28px;

  font-weight: normal;
  background: none;
  border: none;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 32px;
}

.luckdraw_bg {
  width: 100%;
  /* background-image: url('./../assets/img/luckbg.png');
    background-size: 100%; */
}

.luckbg {
  width: 100%;
}
.popup_btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.14667rem;
}

.btn_cancel {
  background: #F0F1F7 !important;
  width: 3.14667rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 1.17333rem;
    border-radius: 0.10667rem;
    color: #171a1d;
}

.btn_confirm {
  background: #06C0F6 !important;
  width: 3.14667rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 1.17333rem;
    border-radius: 0.10667rem;
    color: #fff;
}

.input_adddress {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all 0.2s;
  transform: scale(0);
}

.input_adddress.inputOpen {
  transform: scale(1);
}

.form {
  width: 100%;
}
.msg {
    color: #F9121A;
    font-size: 22px;
    line-height: 33px;
    padding: 0 29px;
  }
.formItem {
  display: flex;
  height: 90px;
  background: #F3F3F3;
  border-radius: 8px;
  overflow: hidden;
  padding: 0 30px;
  margin-bottom: 16px;
}
.label {
    width: 170px;
    color: rgba(23, 26, 29, 1);
    font-size: 26px;
    font-weight: 400;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;

   
  }
.value {
    flex: auto;
    border: none;
    outline: none;
    background: none;
    text-align: right;
    font-size: 26px;
    color: #171A1D;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
.zh {
  font-weight: 600;
  font-size: 26px;
  }     

.en {
    font-weight: 400;
    font-size: 18px;
  }
.areatext {
  height: 168px;

  
}
.value {
    line-height: 44px;
    padding: 25px 0;
    box-sizing: border-box;
    resize: none;
  }
.popup_box {
  width: 612px;
  /* height: 367px; */
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  box-sizing: border-box;
  padding: 31px 41px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.popup_box2 {
  background: #fff;
}

.xypopup {
  width: 595px;
  height: 559px;
  position: relative;
}

.xybutton {
  position: absolute;
  display: block;
  width: 262px;
  height: 85px;
  cursor: pointer;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
}

.my_jf {
  width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 240px;
  left: calc(50% - 150px);
}

.my_jf img {
  width: 100%;
}

.my_jf p {
  /* height: ; */
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  font-size: 24px;

  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}

.luckdraw_box {
  width: 650px;
  height: 650px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 420px;
  left: calc(50% - 325px);
  overflow: hidden;
  border-radius: 50%;
}

.animation_box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.luckdraw_pan {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.luckdraw_btn {
  width: 230px;
  z-index: 2;
}

.luckdraw_item {
  width: 200px;
  height: 200px;
  position: absolute;
  /* background: aqua; */
  /* display: flex; */
  justify-content: center;
  align-items: center;
  flex-direction: column;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  display: none;
}

.luckdraw_item0 {
  transform: translateY(-170px);
  display: flex;
}

.luckdraw_item1 {
  transform: rotate(60deg) translateY(-170px);
  display: flex;
}

.luckdraw_item2 {
  transform: rotate(120deg) translateY(-170px);
  display: flex;
}

.luckdraw_item3 {
  transform: rotate(180deg) translateY(-170px);
  display: flex;
}

.luckdraw_item4 {
  transform: rotate(240deg) translateY(-170px);
  display: flex;
}

.luckdraw_item5 {
  transform: rotate(300deg) translateY(-170px);
  display: flex;
}

.luckdraw_item0 .prize_name,
.luckdraw_item2 .prize_name,
.luckdraw_item4 .prize_name {
  font-size: 12px;

  font-weight: bold;
  color: #6ad9fa;
}

.luckdraw_item1 .prize_name,
.luckdraw_item3 .prize_name,
.luckdraw_item5 .prize_name {
  font-size: 12px;

  font-weight: bold;
  color: #ffffff;
}

.luckdraw_item_img {
  width: 150px;
  height: 86px;
  text-align: center;
  margin-bottom: 10px;
}

.luckdraw_item img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;

}

.rule {
  width: 80%;
  height: 300px;
  position: absolute;
  top: 1250px;
  left: 10%;
  font-size: 28px;

  color: rgba(23, 26, 29, 1);
  line-height: 40px;
  overflow-y: scroll;
}

@media screen and (min-width: 450px) {
  .my_jf {
    top: 300px;
  }

  .luckdraw_box {
    top: 520px;
    width: 800px;
    height: 800px;
    left: calc(50% - 400px);
  }

  .rule {
    top: 1550px;
  }
}

.show_popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background: rgba(23,26,29,.5); */
  z-index: 1000;
}

.luckydraw_log {
  width: 149px;
  height: 75px;
  background: rgba(107, 218, 250, 1);
  border: 4px solid rgba(44, 157, 221, 1);
  border-radius: 38px 0px 0px 38px;
  position: absolute;
  top: 70px;
  right: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 28px;

  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  border-right: none;
}

.text_en {
  font-size: 18px;

  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}

.van-dialog__content img {
  width: 220px;
  text-align: center;
  margin: 30px 0 80px;
}

.wintheprize_name {
  font-size: 30px;

  font-weight: normal;
  color: #EC6400;
  font-weight: 900;
  margin-top: 50px;
}

.popup_wintheprize {
  width: 100%;
  height: 100%;
  background: rgba(23, 26, 29, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 6666;
}

.popup_w_box {
  width: 612px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  padding: 60px 40px;
}

.wintheprize_tit {
  font-size: 30px;

  font-weight: normal;
  color: #171A1D;
  margin-bottom: 18px;
  font-weight: 900;
}

.wintheprize_tit_en {
  font-size: 20px;

  font-weight: normal;
  color: rgba(23, 26, 29, 1);
}

.popup_w_box img {
  width: 194px;
}

.godetails {
  width: 502px;
  height: 78px;
  margin-top: 50px;
  background: #06C0F6;
}

.goback {
  width: 344px;
  height: 78px;
  margin-top: 50px;
}

.wintheprize_text_ch {
  font-size: 24px;

  font-weight: normal;
  color: #878787;
}

.wintheprize_text_en {
  font-size: 20px;

  font-weight: normal;
  color: #878787;
}
</style>
<style>
.van-dialog {
  width: 640px !important;
  box-sizing: border-box;
  padding: 44px 55px;
}

.van-dialog__message {
  font-size: 20px !important;

  font-weight: normal;
  color: rgba(23, 26, 29, 1);
  text-align: center;
  margin: 0px 0 80px !important;

}

.van-dialog__footer--buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.van-dialog__cancel {
  width: 236px !important;
  max-width: 236px !important;
  height: 78px !important;
  background: rgba(240, 241, 247, 1) !important;
  border-radius: 8px !important;
  font-size: 30px !important;

  font-weight: normal;
  color: rgba(23, 26, 29, 1) !important;
}

/* van-button van-button--default van-button--large van-dialog__confirm van-hairline--left */
.van-dialog__confirm {
  width: 236px !important;
  max-width: 236px !important;
  height: 78px !important;
  background: rgba(107, 218, 250, 1) !important;
  border-radius: 8px !important;
  font-size: 30px !important;

  font-weight: normal;
  color: rgba(255, 255, 255, 1) !important;
}

.luckdraw .van-dialog__content {
  text-align: center;
}

.luckdraw .van-dialog__footer {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.van-dialog__header {
  margin-bottom: 5px;
  font-size: 30px;

  font-weight: normal;
  color: rgba(23, 26, 29, 1);
}

.popup_wintheprize .van-dialog__confirm {
  width: 306px !important;
  max-width: 306px !important;
  height: 78px;
  background: rgba(107, 218, 250, 1);
  border-radius: 8px;
}
</style>
  